import React from "react";
import { InquiryCard } from "@pages/myPage/_component/index";
import { useApiRequest } from "@utils/ApiRequest";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

const PurchaseInquiryList = () => {
  const { getPurchaseQnaList } = useApiRequest();
  const navigate = useNavigate();

  const { data: purchaseQnaList } = useQuery({
    queryKey: ["purchaseQnaList"],
    queryFn: getPurchaseQnaList,
  });

  const handleClick = (id: number) => {
    navigate(`/product-qna/${id}`);
  };
  return (
    <>
      {purchaseQnaList?.map((item: any, index: number) => (
        <InquiryCard
          key={index}
          name={item.nickname}
          content={item.question}
          time={item.created_at}
          item={item.product_name}
          read={!item.is_read}
          onClick={() => handleClick(item.product_id)}
        />
      ))}
    </>
  );
};

export default PurchaseInquiryList;
